import { render } from "./attachmentItem.vue?vue&type=template&id=2d4e160b&scoped=true"
import script from "./attachmentItem.vue?vue&type=script&lang=js"
export * from "./attachmentItem.vue?vue&type=script&lang=js"

import "./attachmentItem.vue?vue&type=style&index=0&id=2d4e160b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4e160b"]])

export default __exports__